import { render, staticRenderFns } from "./ConfigMultiListElement.vue?vue&type=template&id=28fa2229&scoped=true&"
import script from "./ConfigMultiListElement.vue?vue&type=script&lang=js&"
export * from "./ConfigMultiListElement.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMultiListElement.vue?vue&type=style&index=0&id=28fa2229&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa2229",
  null
  
)

export default component.exports